import { Button, Grid, Input, Label, Stack, Switch } from '@careflux/primitives';
import { FilterSelect } from './FilterSelect';
import type { FilterBarProps } from './components.types';
import { MODE_OPTIONS } from './formatting';
import type { SummaryMode } from './types';

export const SummaryQualityFilterBar = ({
  filters,
  options,
  optionsLoading,
  hasActiveFilters,
  onChange,
  onClear,
}: FilterBarProps) => (
  <Stack gap="md" className="rounded-md border p-4">
    <Grid columns={{ base: 1, md: 2, xl: 4 }} gap="md">
      <Stack gap="xs">
        <Label htmlFor="summary-quality-from">Frá</Label>
        <Input
          id="summary-quality-from"
          type="date"
          value={filters.from}
          onChange={(event) => onChange({ from: event.target.value })}
        />
      </Stack>
      <Stack gap="xs">
        <Label htmlFor="summary-quality-to">Til</Label>
        <Input
          id="summary-quality-to"
          type="date"
          value={filters.to}
          onChange={(event) => onChange({ to: event.target.value })}
        />
      </Stack>
      <FilterSelect
        id="summary-quality-org"
        label="Stofnun"
        allLabel="Allar stofnanir"
        value={filters.orgId}
        options={options.orgs}
        disabled={optionsLoading}
        onChange={(orgId) => onChange({ orgId, accountId: null })}
      />
      <FilterSelect
        id="summary-quality-user"
        label="Notandi"
        allLabel="Allir notendur"
        value={filters.accountId}
        options={options.users}
        disabled={optionsLoading}
        onChange={(accountId) => onChange({ accountId })}
      />
      <FilterSelect
        id="summary-quality-model"
        label="Líkan"
        allLabel="Öll líkön"
        value={filters.model}
        options={options.models}
        disabled={optionsLoading}
        onChange={(model) => onChange({ model })}
      />
      <FilterSelect
        id="summary-quality-prompt"
        label="Útgáfa fyrirmæla"
        allLabel="Allar útgáfur"
        value={filters.promptHash}
        options={options.promptHashes}
        disabled={optionsLoading}
        onChange={(promptHash) => onChange({ promptHash })}
      />
      <FilterSelect
        id="summary-quality-mode"
        label="Tegund"
        allLabel="Allar tegundir"
        value={filters.mode}
        options={MODE_OPTIONS}
        onChange={(mode) => onChange({ mode: mode as SummaryMode | null })}
      />
      <FilterSelect
        id="summary-quality-template"
        label="Sniðmát"
        allLabel="Öll sniðmát"
        value={filters.templateId}
        options={options.templates}
        disabled={optionsLoading}
        onChange={(templateId) => onChange({ templateId })}
      />
    </Grid>
    <Stack direction="horizontal" justify="between" align="center">
      <Stack direction="horizontal" gap="sm" align="center">
        <Switch
          id="summary-quality-backfilled"
          checked={filters.includeBackfilled}
          onCheckedChange={(includeBackfilled) => onChange({ includeBackfilled })}
        />
        <Label htmlFor="summary-quality-backfilled">Taka með eldri (endurreiknuð) gögn</Label>
      </Stack>
      {hasActiveFilters && (
        <Button type="button" variant="outline" onClick={onClear}>
          Hreinsa síur
        </Button>
      )}
    </Stack>
  </Stack>
);
